/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveLocationWebsites from './receive-location-websites';

export default (query = { page: 1, limit: 20 }) => (dispatch) => {
    dispatch({
        type: actions.LOCATION_WEBSITES_REQUEST,
    });

    return cecSdk
        .locationWebsite()
        .list(query)
        .then((result) => {
            dispatch({
                type: actions.LOCATION_WEBSITES_REQUEST_SUCCESS,
            });
            let locationWebsites = get(result, '_embedded.items');
            dispatch(receiveLocationWebsites(locationWebsites));
            return result;
        })
        .catch((e) => {
            dispatch({ type: actions.LOCATION_WEBSITES_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
